import {configureStore} from '@reduxjs/toolkit';
import productreducer from './reduxLib/productLib';
import categoryreducer from './reduxLib/pcategoriesLib';
import visitorreducer from './reduxLib/visitorLib';
import sessionreducer from './reduxLib/sessionLib';
import actionreducer from './reduxLib/actionLib';
import orderreducer from './reduxLib/ordersLib';
import colorreducer from './reduxLib/colorsLib';
import adressreducer from './reduxLib/adressLib';
import deliveryreducer from './reduxLib/deliveryLib';
import invoicereducer from './reduxLib/invoiceLib';
import userreducer from './reduxLib/userLib';
import shoppingcardreducer from './reduxLib/shoppingcardLib';
import paymentreducer from './reduxLib/paymentLib';

export default configureStore({
    reducer:{
        productreducer,
        categoryreducer,
        visitorreducer,
        sessionreducer,
        actionreducer,
        orderreducer,
        colorreducer,
        adressreducer,
        deliveryreducer,
        invoicereducer,
        userreducer,
        shoppingcardreducer,
        paymentreducer,
    }
});